howspace.components.itemPicker = (() => {
    'use strict';

    const popovers = new WeakMap();

    const updateLegacyCollapses = (itemPicker) => {
        if (itemPicker.find('.item').length <= 100) {
            return;
        }

        let firstGroup = itemPicker.find('.item-group:has(.item.matched) button[aria-controls]')[0] || null;
        if (firstGroup === null) {
            firstGroup = itemPicker.find('.item-group:has(.item:not(.selected)) button[aria-controls]')[0] || null;
        }
        if (firstGroup) {
            howspace.components.collapse.expand(firstGroup, false);
        }

        itemPicker.find('.item-group button[aria-controls][aria-expanded="true"]').each(function () {
            if (this !== firstGroup) {
                howspace.components.collapse.collapse(this, false);
            }
        });
    };

    const updateCollapses = (itemPicker) => {
        if (itemPicker.data('collapse-opt-groups-by-default') !== true) {
            updateLegacyCollapses(itemPicker);
            return;
        }

        const searching = itemPicker.find('.item-groups').hasClass('searching');

        itemPicker.find('.item-group button[aria-controls]').each(function () {
            const group = $(this).closest('.item-group');
            const shouldExpand = searching && group.find('.item:not(.selected).matched').length > 0;

            if (shouldExpand && this.getAttribute('aria-expanded') !== 'true') {
                howspace.components.collapse.expand(this, false);
            } else if (!shouldExpand && this.getAttribute('aria-expanded') === 'true') {
                howspace.components.collapse.collapse(this, false);
            }
        });
    };

    const updateFilters = (itemPicker) => {
        itemPicker.find('.filter-type-btn').each(function() {
            const filter = $(this);
            const type = filter.data('type');
            const count = itemPicker.find(`.item[data-type="${type}"]:not(.selected)`).length;
            if (count === 0) {
                filter.addClass('d-none').removeClass('btn-primary').addClass('btn-secondary').attr('aria-pressed', 'false');
            } else {
                filter.removeClass('d-none');
            }
        });
    };

    return {
        ITEM_ADDED: 'item-picker-item-added',
        ITEM_REMOVED: 'item-picker-item-removed',
        init: elem => {
            elem.findIncludingSelf('.howspace-item-picker:not(.howspace-item-picker-initialized)').each(function () {
                const itemPicker = $(this);
                itemPicker.addClass('howspace-item-picker-initialized');

                const selectedItems = itemPicker.find('.selected-items .howspace-sortable-list-items');
                const searchInput = itemPicker.find('.howspace-form-search-input');
                const filterTypeButtons = itemPicker.find('.filter-type-btn');
                const itemGroups = itemPicker.find('.item-groups');
                const unselectedItems = itemGroups.find('.howspace-sortable-list');
                const statusMessage = itemPicker.find('[data-status-message]');

                const announce = (message) => {
                    // Toggle the text via empty string so repeated identical messages are re-announced.
                    statusMessage.text('');
                    requestAnimationFrame(() => statusMessage.text(message));
                };

                const search = (value, addedItem = false) => {
                    value = value.toLowerCase().trim();

                    const filterType = itemPicker.find('.filter-type-btn.btn-primary').data('type') ?? null;

                    if (value.length > 0 || filterType) {
                        itemGroups.addClass('searching');

                        // match items by title and type
                        unselectedItems.find('.item:not(.selected)').each(function () {
                            const item = $(this);
                            // String casting due widget titles such as "1" get turned into ints by
                            // jQuery data(), which then crashes on the includes() below.
                            const title = String(item.data('title') || '');
                            const type = item.data('type');

                            if (title.includes(value) && (!filterType || filterType === type)) {
                                item.addClass('matched');
                            } else {
                                item.removeClass('matched');
                            }
                        });

                        // match groups by title
                        itemGroups.find('.item-group:has(.item:not(.selected))').each(function () {
                            const group = $(this);
                            const title = group.data('title');

                            if (title.includes(value)) {
                                if (filterType) {
                                    group.find(`.item[data-type="${filterType}"]:not(.selected)`).addClass('matched');
                                } else {
                                    group.find('.item:not(.selected)').addClass('matched');
                                }
                            }
                        });
                    } else {
                        itemGroups.removeClass('searching');
                        unselectedItems.find('.item:not(.selected)').removeClass('matched');
                    }

                    if (!addedItem) {
                        updateCollapses(itemPicker);
                    }
                };

                updateCollapses(itemPicker);

                const onAddItemCollapseExpanding = (e) => {
                    if (e.target !== e.currentTarget) {
                        // ignore events from item group cards
                        return;
                    }

                    if (!addItemPopover.length) {
                        searchInput[0].scrollIntoView({behavior: 'smooth', block: 'start'});
                    }

                    if (!addItemPopover.length && !howspace.isMobile()) {
                        real.input.focus(searchInput);
                    }

                    updateFilters(itemPicker);
                };

                const onAddItemCollapseCollapsing = (e) => {
                    if (e.target !== e.currentTarget) {
                        // ignore events from item group cards
                        return;
                    }

                    // set aria-expanded attribute to false
                    itemPicker.find('.add-item-btn').attr('aria-expanded', false);
                };

                const onAddItemCollapseCollapsed = (e) => {
                    if (e && e.target !== e.currentTarget) {
                        // ignore events from item group cards
                        return;
                    }

                    // clear checkboxes
                    unselectedItems.find('.checkbox').prop('checked', false);

                    // clear type filter
                    filterTypeButtons.removeClass('btn-primary').addClass('btn-secondary').attr('aria-pressed', 'false');

                    // clear search
                    searchInput.val(null).trigger('input');

                    if (!addItemPopover.length) {
                        itemPicker.find('.add-item-btn')[0]?.focus();
                    }
                };

                const addItemCollapse = itemPicker.find('.add-item-collapse');
                const addItemPopover = itemPicker.find('.add-item-popover');
                const addButton = itemPicker.find('.add-item-btn')[0];
                if (addItemPopover.length) {
                    popovers.set(this, howspace.popover.bind(addButton, addItemPopover, {
                        onOpen: () => updateFilters(itemPicker),
                        onClose: () => onAddItemCollapseCollapsed(),
                        getInitialFocus: () => howspace.isMobile() ? addItemPopover[0] : searchInput[0],
                        getReturnFocus: () => addButton.disabled
                            ? selectedItems.find('.delete-item-btn')[0]
                            : addButton
                    }));
                }
                const closePicker = () => {
                    if (addItemPopover.length) {
                        popovers.get(itemPicker[0]).close();
                    } else {
                        howspace.components.collapse.close(addItemCollapse);
                    }
                };

                addItemCollapse.on(howspace.components.collapse.EXPANDING, onAddItemCollapseExpanding);
                addItemCollapse.on(howspace.components.collapse.COLLAPSING, onAddItemCollapseCollapsing);
                addItemCollapse.on(howspace.components.collapse.COLLAPSED, onAddItemCollapseCollapsed);

                itemPicker.find('.close-collapse-btn').on('click', () => {
                    closePicker();
                });

                itemPicker.on('input', '.value', (e) => {
                    const input = $(e.currentTarget);
                    const value = input.val();

                    // find the corresponding checkbox
                    const checkbox = input.closest('.item').find('.checkbox');

                    // update the value of the checkbox
                    const checkboxValue = JSON.parse(checkbox.val());
                    checkboxValue.value = value;
                    checkbox.val(JSON.stringify(checkboxValue));
                });

                const deleteItem = e => {
                    const btn = $(e.currentTarget);
                    const item = btn.closest('.item');

                    // show item in unselected items
                    const unselectedItem = unselectedItems.find(`.item[data-id="${item.data('id')}"]`);
                    unselectedItem.removeClass('selected');

                    // clear checkbox
                    unselectedItem.find('.checkbox').prop('checked', false).prop('disabled', false);

                    // remove item from selected items
                    item.velocity('slideUp', 'fast', () => {
                        announce(item.data('title'));
                        item.remove();

                        // hide sortable list in case it's empty
                        itemPicker.find('.selected-items:not(:has(.item))').addClass('d-none');

                        // trigger ITEM_REMOVED event
                        howspace.dispatchEvent(itemPicker, howspace.components.itemPicker.ITEM_REMOVED, {
                            item: {
                                id: item.data('id'),
                                type: item.data('type')
                            }
                        });
                    });

                    // enable Add item button
                    itemPicker.find('.add-item-btn').prop('disabled', false);

                    // update filters
                    updateFilters(itemPicker);

                    // search
                    search(searchInput.val());
                };

                itemPicker.on('click', '.delete-item-btn', deleteItem);

                searchInput.on('input', () => search(searchInput.val()));

                filterTypeButtons.on('click', e => {
                    const btn = $(e.currentTarget);

                    if (btn.hasClass('btn-secondary')) {
                        filterTypeButtons.removeClass('btn-primary').addClass('btn-secondary').attr('aria-pressed', 'false');
                        btn.removeClass('btn-secondary').addClass('btn-primary').attr('aria-pressed', 'true');
                    } else {
                        btn.removeClass('btn-primary').addClass('btn-secondary').attr('aria-pressed', 'false');
                    }

                    search(searchInput.val());
                });

                const addItem = e => {
                    const checkbox = $(e.currentTarget);
                    if (!checkbox.prop('checked')) {
                        return;
                    }

                    // Disable immediately so rapid keypresses cannot queue a second addition.
                    // The item will be hidden by the .selected class shortly after.
                    checkbox.prop('disabled', true);

                    const item = checkbox.closest('.item');

                    setTimeout(() => {
                        // show sortable list in case it's empty
                        itemPicker.find('.selected-items').removeClass('d-none');

                        // mark item as selected
                        item.addClass('selected');
                        const clone = item.clone();

                        // show item in selected items
                        selectedItems.append(clone);
                        clone.velocity('slideDown', {
                            duration: 'fast',
                            display: 'flex'
                        });

                        // clear checkbox
                        checkbox.prop('checked', false);

                        // update filters
                        updateFilters(itemPicker);

                        // search
                        search(searchInput.val(), true);

                        // set Add item button disabled if no items are left unselected
                        if (unselectedItems.find('.item:not(.selected)').length === 0) {
                            itemPicker.find('.add-item-btn').prop('disabled', true);
                            closePicker();
                        }

                        announce(item.data('title'));

                        // trigger ITEM_ADDED event
                        howspace.dispatchEvent(itemPicker, howspace.components.itemPicker.ITEM_ADDED, {
                            item: {
                                id: item.data('id'),
                                type: item.data('type')
                            }
                        });
                    }, 350);
                };

                unselectedItems.find('.checkbox').on('change', addItem);
            });
        },
        destroy: elem => {
            elem.findIncludingSelf('.howspace-item-picker.howspace-item-picker-initialized').each(function () {
                const itemPicker = $(this);
                popovers.get(this)?.destroy();
                popovers.delete(this);
                itemPicker.removeClass('howspace-item-picker-initialized');
            });
        },
    };
})();
